module.exports = __webpack_public_path__ + "assets/img/image-loading.0a5bdba3.svg";